import { SetSelectedSiteId } from 'libs/reducers/src/lib/metadata-reducer/metatada.reducer';

export function computeKwickInvoicesSiteIds(
  metadata: any,
  pathSegment: string,
  params: any
): string[] {
  const ENV = (import.meta as any).env;
  if (!metadata || metadata?.entities?.length === 0) return [];
  const sites = metadata?.entities?.sites || null;
  if (!sites) return [];

  let context: 'member' | 'community' | 'site' | 'communities' | null = null;
  if (pathSegment?.includes('member')) context = 'member';
  if (pathSegment?.includes('community')) context = 'community';
  if (pathSegment?.includes('site') || pathSegment?.includes('household'))
    context = 'site';
  if (pathSegment?.includes('communities')) context = 'communities';
  let siteIds: string[] = [];

  if (ENV?.VITE_APP_IS_WEB === 'false') {
    if (pathSegment?.includes('community')) {
    
      const findSite = sites.find(
        (site: any) => site.communityId === params?.id
      );
      let id = metadata?.selectedSiteId || metadata?.prevSelectedEntityId;
      if (
        metadata?.selectedEntityId &&
        metadata?.prevSelectedEntityId !== metadata?.selectedEntityId
      ) {
        id = metadata?.selectedEntityId;
      }

      siteIds = id && id !== 'null' ? [id] : [findSite[0]?.siteId];
    } else {
      siteIds.push(params?.id as string);
    }
  } else if (ENV?.VITE_APP_IS_WEB === 'true') {
    if (context === 'site') {
      siteIds.push(params?.id as string);
    }
    if (context === 'member') {
      // CM-5128: `selectedEntity` lags one navigation behind — on member A →
      // member B, params.id is already B while selectedEntity still holds A
      // (MemberResolver's fetch is async). Building the request from the stale
      // entity queries the WRONG member's sites; bail out until they match.
      // The resolver re-runs when SetSelectedEntity lands (metadata dep), and
      // Billing's refresh goes through this same helper, so both are covered.
      if (metadata?.selectedEntity?.memberId !== params?.id) {
        return [];
      }
      // Use sites from selectedEntity (works for current AND past members).
      // CM-5124: the member detail endpoint returns ALL sites of the member,
      // unscoped, so for a supervisor it can include sites of communities they
      // don't supervise. getInvoices denies the whole batch when one site is
      // out of scope, so keep only the sites visible in `entities` (scoped).
      const inScope = new Set(
        sites.map((site: any) => site?.siteId).filter(Boolean)
      );
      const memberSites = metadata?.selectedEntity?.sites || [];
      siteIds = memberSites
        .map((site: any) => site.siteId)
        .filter((siteId: string) => inScope.has(siteId));

      // Fallback to entities.sites if selectedEntity has no sites
      if (siteIds.length === 0) {
        siteIds = sites
          .filter((site: any) => site.memberId === params?.id)
          .map((site: any) => site.siteId);
      }
    }
    if (context === 'community') {
      siteIds = sites
        .filter((site: any) => {
          if (site.communityId === params?.id) return true;
          if (site.changelog && Array.isArray(site.changelog)) {
            return site.changelog.some((entry: any) => entry.communityId === params?.id);
          }
          return false;
        })
        .map((site: any) => site.siteId);
    }
    if (context === 'communities') {
      siteIds = sites.map((site: any) => site.siteId);
    }

    siteIds = (siteIds || []).filter(
      (siteId: string) => siteId !== null && siteId !== undefined
    );

    if (siteIds.length > 1 && context === 'site') {
      return [];
    }
  }

  return siteIds;
}
